import Project from "../utils/services/projectService";
import crudTemplate from "../templates/crudTemplate";
import router from "../../router";
import authorizationTemplate from "../templates/authorizationTemplate";
let crud = crudTemplate(Project);
let authorization = authorizationTemplate(Project);
let isWorkWithCurrentProject = () =>
  router.app.$route.params.project_id ||
  (router.app.$route.name === "project" && router.app.$route.params.id);
const state = {
  currentProject: {},
  ...crud.state,
  ...authorization.state
};
function prepareItem(item) {
  if (item.terminated_at) {
    item._permissions = (item._permissions || []).filter(i =>
      /(\.read|\.list)/.test(i)
    );
  }
  return item;
}
const getters = {
  ...crud.getters,
  ...authorization.getters,
  getCurrentItem(state) {
    return prepareItem(state.currentProject);
  },
  isWorkWithCurrentProject() {
    return isWorkWithCurrentProject();
  }
};

const actions = {
  ...crud.actions,
  ...authorization.actions,
  terminate(_, { params, onError = () => {}, onSuccess = () => {} }) {
    return Project.terminate(params, onSuccess, onError);
  },
  cancelTermination(_, { params, onError = () => {}, onSuccess = () => {} }) {
    return Project.cancelTermination(params, onSuccess, onError);
  }
};

const mutations = {
  ...crud.mutations,

  set(state, { item, setCurrentProject = false }) {
    state.item = item;
    if (setCurrentProject || isWorkWithCurrentProject()) {
      state.currentProject = item;
    }
  },
  setList(state, { list, page, setCurrentProject = false }) {
    state.list = list;
    state.page = page;
    let id = isWorkWithCurrentProject();
    if (setCurrentProject || id) {
      state.currentProject = list.find(item => item.id === id);
    }
  },
  ...authorization.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
